import { Component, Inject, PLATFORM_ID, Renderer2, afterNextRender, ViewChild, AfterViewInit } from '@angular/core';
import { DOCUMENT, isPlatformBrowser, AsyncPipe, CommonModule } from '@angular/common';
import { MatMenuTrigger } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { AuthService } from './services/auth.service';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [
    CommonModule,
    RouterModule,
    MatToolbarModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    AsyncPipe
],
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements AfterViewInit {
  title = 'RRBootcamp';

  @ViewChild('menuTrigger') menuTrigger: MatMenuTrigger | undefined;

  constructor(
    public auth: AuthService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    // Add bg-loaded class after hydration to show background image
    afterNextRender(() => {
      if (isPlatformBrowser(this.platformId)) {
        this.renderer.addClass(this.document.body, 'bg-loaded');
      }
    });
  }

  ngAfterViewInit(): void {
    // Close the menu overlay when auth state changes to avoid stale open menus showing old state
    if ((this.auth as any).loggedIn$ && typeof (this.auth as any).loggedIn$.subscribe === 'function') {
      (this.auth as any).loggedIn$.subscribe(() => {
        try {
          this.menuTrigger?.closeMenu();
        } catch (e) {
          // no-op
        }
      });
    }
  }

}
